/**
 *
 * @param {ZFolio} zfolioMain
 * @param pargs
 * @param {Function} excerpt_content_resize_vplayer
 * @param {Function} calculate_dims
 */
export function zfolio_handleResize(zfolioMain, pargs, excerpt_content_resize_vplayer, calculate_dims) {



  var margs = {
    calculate_dims_init: true
    , calculate_excerpt_con: true
    , excerpt_con_noanimation: true

  };


  if (pargs) {
    margs = $.extend(margs, pargs);
  }

  const o = zfolioMain.mainOptions;

  zfolioMain.ww = window.innerWidth;
  zfolioMain.wh = window.innerHeight;
  zfolioMain.tw = zfolioMain.cthis.width();


  if (zfolioMain.ww <= 520) {
    zfolioMain.cthis.addClass('under-520');
  } else {

    zfolioMain.cthis.removeClass('under-520');
  }
  if (zfolioMain.ww <= 720) {
    zfolioMain.cthis.addClass('under-720');
    if(zfolioMain._selectorCon) {

      zfolioMain._selectorCon.addClass('selector-responsive-mode')
    }
    if (zfolioMain.mainOptions.outer_con_selector_con) {
      zfolioMain.mainOptions.outer_con_selector_con.addClass('under-720');
    }
  } else {

    zfolioMain.cthis.removeClass('under-720');

    if(zfolioMain._selectorCon){

      zfolioMain._selectorCon.removeClass('selector-responsive-mode')
    }
    if (o.outer_con_selector_con) {
      o.outer_con_selector_con.removeClass('under-720');
    }
  }
  if (zfolioMain.ww <= 1000) {
    zfolioMain.cthis.addClass('under-1000');

    if (o.outer_con_selector_con) {
      o.outer_con_selector_con.addClass('under-1000');
    }
  } else {

    zfolioMain.cthis.removeClass('under-1000');
    if (o.outer_con_selector_con) {

      o.outer_con_selector_con.removeClass('under-1000');
    }
  }

  if (margs.calculate_excerpt_con) {


    if (zfolioMain._excerptContent_initialPortItem) {
      if (o.excerpt_con_resize_videos === 'on') {

        excerpt_content_resize_vplayer();
      }
    }


    setTimeout(function () {
      if (zfolioMain._excerptContent_initialPortItem) {
        zfolioMain._tcon_content.css({
          'padding': zfolioMain._excerptContent.css('padding-top')
          , 'width': zfolioMain.cthis.outerWidth()
        })


        let auxh = 0;
        if (o.excerpt_con_transition === 'zoom') {
          zfolioMain._excerptContentCon.css({});

          auxh = zfolioMain._tcon_content.outerHeight();


          if (zfolioMain._excerptContent.find('.advancedscroller').length > 0) {
            auxh -= 1;
          }
          zfolioMain._excerptContent.css({
            'height': auxh
          });
        } else {

          auxh = zfolioMain._tcon_content.outerHeight();

          if (margs.excerpt_con_noanimation) {

            auxh = zfolioMain._excerptContent.children('.dzs-colcontainer').outerHeight();

            if (zfolioMain._excerptContent.find('.advancedscroller').length > 0) {
              auxh -= 1;
            }

            zfolioMain._excerptContent.css({
              'height': auxh
            });


            zfolioMain._excerptContentCon.css({
              'height': ''
            });
          }


        }

      }

    }, 500)

  }


  if (margs.calculate_dims_init) {

    if (zfolioMain.inter_calculate_dims) {
      clearTimeout(zfolioMain.inter_calculate_dims);
    }
    zfolioMain.inter_calculate_dims = setTimeout(calculate_dims, 300);
  }
}
